import React from "react";
import { Link } from "react-router-dom";
import "./button-en.css";
function ButtonEnglish() {
  return (
    <div>
      <Link
        className="En-bt"
        to="/Englishpage"
        component="Button"
        style={{
          textDecoration: "none",
          padding: "4px",
          fontSize: "1.5rem",
          // margin: "1px 5px",
          fontFamily: "roboto",
          // float: "left",
        }}
      >
        En
      </Link>
    </div>
  );
}

export default ButtonEnglish;
